<span [matTooltip]="state.timeAgo" [matTooltipDisabled]="!showTooltip">{{ state.timeAgo }}</span>
